import { create } from 'zustand';
import { User, Capability } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
  capabilities: Capability[];
  isAuthenticated: boolean;
  setUser: (user: User) => void;
  setToken: (token: string) => void;
  setCapabilities: (capabilities: Capability[]) => void;
  logout: () => void;
  loadUser: () => void;
}

const getStoredUser = (): User | null => {
  const stored = localStorage.getItem('user');
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  }
  return null;
};

const getStoredCapabilities = (): Capability[] => {
  const stored = localStorage.getItem('capabilities');
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return [];
    }
  }
  return [];
};

export const useAuthStore = create<AuthState>((set) => ({
  user: getStoredUser(),
  token: localStorage.getItem('token'),
  capabilities: getStoredCapabilities(),
  isAuthenticated: !!localStorage.getItem('token'),

  setUser: (user) => {
    const userWithTimestamp = {
      ...user,
      updated_at: user.updated_at || new Date().toISOString(),
    };
    localStorage.setItem('user', JSON.stringify(userWithTimestamp));
    if (user?.role?.name) {
      localStorage.setItem('user_role', user.role.name);
    }
    set({ user: userWithTimestamp, isAuthenticated: true });
  },

  setToken: (token) => {
    localStorage.setItem('token', token);
    set({ token, isAuthenticated: true });
  },

  setCapabilities: (capabilities) => {
    localStorage.setItem('capabilities', JSON.stringify(capabilities));
    set({ capabilities });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_role');
    localStorage.removeItem('capabilities');
    set({ user: null, token: null, capabilities: [], isAuthenticated: false });
  },

  loadUser: () => {
    const user = getStoredUser();
    const token = localStorage.getItem('token');
    const capabilities = getStoredCapabilities();
    if (token && user) {
      set({ user, token, capabilities, isAuthenticated: true });
    }
  },
}));
